import axios from '../request/http.js'
import { handleGetRequestParams } from '../common/js/utils.js'


class Risk {
  /* 风险分类列表 */
  static getRiskTypeLsit() {
    let url = `/zzd/api/back/risk/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除风险分类 */
  static postDelRiskType(data) {
    let url = `/zzd/api/back/risk/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存风险分类 */
  static postSaveRiskType(data) {
    let url = `/zzd/api/back/risk/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险细项列表 */
  static getRiskDetailsList(options) {
    let url = `/zzd/api/back/risk/item/page?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除风险细项 */
  static postDelRiskDetails(data) {
    let url = `/zzd/api/back/risk/item/del`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存风险细项 */
  static postSaveRiskDetails(data) {
    let url = `/zzd/api/back/risk/item/save`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险发布列表 */
  static getRiskReleaseList(options) {
    let url = `/zzd/api/back/risk/task/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 撤销 */
  static postRevokeTask(data) {
    let url = `/zzd/api/back/risk/task/revoke`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险发布基本信息 */
  static getRiskReleaseBaseInfo(id) {
    let url = `/zzd/api/back/risk/task/detail?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险分布内容列表 */
  static getRiskReleaseContentList(options) {
    let url = `/zzd/api/back/risk/task/list/item?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险分布责任主体详情 */
  static getRiskReleaseDirectorDetails(riskTaskItemId) {
    let url = `/zzd/api/back/risk/task/detail/item?riskTaskItemId=${riskTaskItemId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险分布责任主体列表 */
  static getRiskReleaseRiskCompanyList(riskTaskItemId) {
    let url = `/zzd/api/back/risk/task/list/unit?riskTaskItemId=${riskTaskItemId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险细项列表 */
  static getRiskTaskDetailsList(options) {
    let url = `/zzd/api/back/risk/item/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 风险发布 */
  static postPublishTask(data) {
    let url = `/zzd/api/back/risk/task/publish`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 任务记录列表 */
  static getTaskRecordList(options) {
    let url = `/zzd/api/back/risk/overview/list/task?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 任务记录--风险分类列表 */
  static getTaskRecordRiskTypeLsit(riskTaskId) {
    let url = `/zzd/api/back/risk/list?riskTaskId=${riskTaskId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 任务记录--风险细项列表 */
  static getTaskRecordRiskDetailsLsit(riskTaskCategoryId) {
    let url = `/zzd/api/back/risk/task/item/list?riskTaskCategoryId=${riskTaskCategoryId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 预警总览列表 */
  static getRiskOverviewList(options) {
    let url = `/zzd/api/back/risk/overview/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 保存分值 */
  static postSavePoints(data) {
    let url = `/zzd/api/back/risk/overview/score`
    return axios.post(url,data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 评分详情 */
  static getScoreDetails(riskTaskId) {
    let url = `/zzd/api/back/risk/overview/list/score?riskTaskId=${riskTaskId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Risk